import { render, staticRenderFns } from "./AdminPropertyCard.vue?vue&type=template&id=71fbfd15&scoped=true&"
import script from "./AdminPropertyCard.vue?vue&type=script&lang=js&"
export * from "./AdminPropertyCard.vue?vue&type=script&lang=js&"
import style0 from "./AdminPropertyCard.vue?vue&type=style&index=0&id=71fbfd15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fbfd15",
  null
  
)

export default component.exports